import type { KnowledgeTreeEntry } from '../types'

export function matchesSearch(query: string, name: string, content?: string | null): boolean {
  const q = query.toLowerCase()
  return name.toLowerCase().includes(q) || (content?.toLowerCase().includes(q) ?? false)
}

export function filterTree(entries: KnowledgeTreeEntry[], query: string): KnowledgeTreeEntry[] {
  if (!query) return entries
  return entries.reduce<KnowledgeTreeEntry[]>((acc, entry) => {
    if (entry.type === 'file') {
      if (matchesSearch(query, entry.name, entry.content)) acc.push(entry)
    } else {
      const filteredChildren = filterTree(entry.children ?? [], query)
      if (filteredChildren.length > 0) acc.push({ ...entry, children: filteredChildren })
    }
    return acc
  }, [])
}
